import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModules } from '../modules/context';
import { buildNavigation } from '../modules/navigation';
import { useSession } from '../session/session';
import type { NavigationTarget } from './setting-control';

/** Pages the person can open, as choices for `navigation-target` settings like the start page. */
export function useNavigationTargets(): NavigationTarget[] {
  const { t } = useTranslation();
  const session = useSession();
  const modules = useModules();
  return useMemo(() => {
    const navigation = buildNavigation(modules, session);
    return [
      { path: '/', label: t('shell.home') },
      ...navigation.flatMap((module) =>
        module.items.map((item) => ({
          path: item.path,
          label: `${t(module.label)} › ${t(item.label)}`,
        })),
      ),
    ];
  }, [modules, session, t]);
}
